// Utility to upload file data arrays to Firebase Storage and return URLs
import { getStorage, ref as storageRef, uploadString, getDownloadURL } from 'firebase/storage';

/**
 * Uploads originalData, originalXValues, originalYValues to Storage and returns URLs.
 * @param {string} uid - User ID
 * @param {string} configId - Config ID
 * @param {string} fileType - 'stdFiles' | 'qcFiles' | 'unkFiles'
 * @param {string} fileName - File name (e.g., 'standard_1.txt')
 * @param {object} fileObj - The file object containing the arrays
 * @param {function} onArrayUploaded - Callback function to track upload progress of each array
 * @returns {Promise<object>} - URLs for each uploaded array
 */
export async function uploadFileArraysToStorage(uid, configId, fileType, fileName, fileObj, onArrayUploaded) {
  const storage = getStorage();
  const basePath = `users/${uid}/results/${configId}/${fileType}/${fileName}`;
  const result = {};

  // Only upload originalData
  async function uploadOriginalData() {
    if (!fileObj.originalData) return undefined;
    const path = `${basePath}/originalData.json`;
    const ref = storageRef(storage, path);
    await uploadString(ref, JSON.stringify(fileObj.originalData), 'raw');
    if (onArrayUploaded) onArrayUploaded();
    return await getDownloadURL(ref);
  }

  result.originalDataUrl = await uploadOriginalData();
  // Do not upload originalXValues or originalYValues

  return result;
}
